"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./Viewer.css");
const mithril_1 = __importDefault(require("mithril"));
const stream_1 = __importDefault(require("mithril/stream"));
const ViewerTable_1 = __importDefault(require("./ViewerTable"));
const ViewerMap_1 = __importDefault(require("./ViewerMap"));
require("../stravaApi");
const Act_1 = require("../Act");
const shared_1 = require("../shared");
const JSONStorageItem_1 = __importDefault(require("../JSONStorageItem"));
const Viewer = ({ attrs: { actData$, actDataSync$, syncDate$, sync } }) => {
    // Modes:
    //   Viewing all acts
    //   Viewing acts filtered by table filters
    //   Viewing specific set of acts defined by a multiclick
    // So we're choosing to TURN OFF all table filtering when there's a multiselection
    const acts$ = actData$.map((actData) => actData.map((data) => new Act_1.Act(data)));
    window.acts$ = acts$;
    const hoveredActIds$ = (0, stream_1.default)([]);
    const multiselectedActIds$ = (0, stream_1.default)([]);
    const selectedActId$ = (0, stream_1.default)(undefined);
    const filterFromTable$ = (0, stream_1.default)(() => true);
    const visibleActs$ = stream_1.default.lift((acts, filterFromTable, multiselectedActIds) => {
        const filteredActs = acts.filter(filterFromTable);
        if (multiselectedActIds.length > 0) {
            return filteredActs.filter((act) => multiselectedActIds.includes(act.data.id));
        }
        else {
            return filteredActs;
        }
    }, acts$, filterFromTable$, multiselectedActIds$);
    // A funny case: if a hovered/selected act is made invisible, it should be de-hovered/selected
    visibleActs$.map((visibleActs) => {
        const visibleHoveredActIds = hoveredActIds$().filter((hoveredActId) => visibleActs.find((act) => act.data.id === hoveredActId));
        if (visibleHoveredActIds.length !== hoveredActIds$().length) {
            hoveredActIds$(visibleHoveredActIds);
        }
        const selectedActId = selectedActId$();
        if (!visibleActs.find((act) => act.data.id === selectedActId)) {
            selectedActId$(undefined);
        }
    });
    // For cross-storage convenience
    const selectedActDataStorage = new JSONStorageItem_1.default('selectedActData');
    selectedActId$.map((selectedActId) => {
        const selectedAct = acts$().find((act) => act.data.id === selectedActId);
        selectedActDataStorage.set(selectedAct === null || selectedAct === void 0 ? void 0 : selectedAct.data);
    });
    (0, shared_1.redrawOn)(actDataSync$, syncDate$);
    return {
        view: () => {
            return [
                (0, mithril_1.default)('.Viewer', [
                    (0, mithril_1.default)('.Viewer-left', (0, mithril_1.default)(ViewerMap_1.default, { visibleActs$, hoveredActIds$, multiselectedActIds$, selectedActId$ })),
                    (0, mithril_1.default)('.Viewer-right', [
                        (0, mithril_1.default)(ViewerTable_1.default, { acts$, filterFromTable$, hoveredActIds$, selectedActId$, visibleActs$ }),
                        (0, mithril_1.default)('.Viewer-controls', (0, mithril_1.default)('', "You are using ", (0, mithril_1.default)('span.Viewer-strava-atlas', "Strava Atlas"), ". ", "View source ", (0, mithril_1.default)('a', { href: 'https://github.com/joshuahhh/strava-atlas' }, 'on GitHub'), "."), (0, mithril_1.default)('', actDataSync$()
                            ? [
                                'Sync in progress: ',
                                (0, mithril_1.default)('span.Viewer-loading-progress.Shared-loading-progress', `${actDataSync$().length} activities`),
                            ]
                            : [
                                `Last synced at ${new Date(syncDate$()).toLocaleString()}. `,
                                (0, mithril_1.default)('button', { onclick: () => sync({ fromScratch: false }) }, 'Sync now'),
                                (0, mithril_1.default)('details.Viewer-advanced-details', (0, mithril_1.default)('summary', 'Advanced'), (0, mithril_1.default)('.Viewer-advanced-controls', (0, mithril_1.default)('button', { onclick: () => sync({ fromScratch: true }) }, 'Sync from scratch'))),
                            ])),
                    ]),
                ]),
            ];
        },
    };
};
exports.default = Viewer;
